import React from 'react'
import { pure } from 'recompose'
import { Link } from 'react-router-dom'
import { Row, Col } from 'pui-react-grids'
import { noop } from 'lodash'
import { Card } from 'material-ui/Card'
import FontIcon from 'material-ui/FontIcon'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import ContentRemove from 'material-ui/svg-icons/content/remove'
import { DENARO_ICON_NAME } from '../../styles/icons'
import AddBox from 'material-ui/svg-icons/content/add-box'
import Chip from 'material-ui/Chip'
import { Rating } from 'material-ui-rating'
import { themeColors } from '../../styles/theme'
import { totalItemsValue } from '../../utils'
import CardItemSwap from './CardItemSwap'

const styles = {
  itemCardContainerStyle: {
    opacity: 1,
    backgroundColor: '#fff',
    marginTop: 15,
  },
  UserContainer: {
    backgroundColor: '#E8E8E8',
    color: themeColors.lightblack,
  },
  UserTitle: {
    paddingTop: '5px',
    paddingLeft: '20px',
    marginBottom: '0px',
  },
  userLabel: {
    marginLeft: 'auto',
    textTransform: 'uppercase',
    fontSize: 10,
    padding: 10,
  },
  totalVal: {
    marginLeft: 'auto',
    textTransform: 'uppercase',
    fontSize: 12,
    paddingRight: 10,
    color: themeColors.neutral,
  },
  place: {
    fontStyle: 'italic',
    paddingLeft: 16,
    marginTop: 0,
    marginBottom: 3,
    fontSize: 13,
  },
  addCashBtn: {
    float: 'right',
  },
  addCashBtnSmall: {
    float: 'right',
    height: 28,
  },
  labelStyle: {
    fontSize: 11,
  },
  labelStyleSmall: {
    fontSize: 9,
    position: 'relative',
    bottom: 1,
  },
  chipSecondary: {
    height: 32,
    marginLeft: 'auto',
    border: '1px solid #FF4081',
  },
  chipPositive: {
    height: 32,
    marginLeft: 'auto',
    border: '1px solid #00b4bc',
  },
  swapBtn: {
    marginTop: 50,
    marginBottom: 50,
  },
  feedback: {
    paddingLeft: 16,
    marginTop: 0,
    marginBottom: 10,
    fontSize: 13,
  },
  feedbackStars: {
    width: 16,
    height: 16,
    padding: 3,
    position: 'relative',
    top: -2,
    left: 3,
  },
  feedbackReason: {
    display: 'flex',
    marginTop: -5,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: 12,
    paddingBottom: 3,
  },
  rmBtn: {
    width: 36,
    minWidth: 36,
  },
}

const iconStyle = {
  place: {
    color: themeColors.lightblack,
  },
  btnIcon: {
    position: 'relative',
    top: -1,
  },
  btnIconSmall: {
    position: 'relative',
    bottom: 0.5,
    height: 16,
    width: 16,
    fontSize: 16,
  },
}

const cashCardStyle = {
  card: {
    marginTop: 15,
    marginBottom: 15,
    textAlign: 'center',
    backgroundColor: themeColors.white,
    height: 100,
  },
  chip: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingRight: 10,
    marginLeft: 'auto',
    marginTop: 10,
    marginBottom: 10,
  },
  icon: {
    marginLeft: 10,
    marginTop: 25,
    marginBottom: 20,
    width: 50,
    height: 50,
    borderRadius: '100%',
    backgroundColor: themeColors.energized,
    fontSize: 30,
    color: themeColors.white,
    paddingTop: 9,
    paddingRight: 3,
  },
  title: {
    marginTop: 35,
    fontSize: 20,
    color: themeColors.energized,
    marginLeft: 5,
  },
}

const SwapManagement = ({
  editable,
  swap,
  onClickProponenteAddItems,
  onClickDestinatarioAddItems,
  onProponenteAddMoney,
  onProponenteItemRemoved,
  onDestinatarioItemRemoved,
  onProponenteClearMoney,
  onDestinatarioClearMoney,
}) => {
  const proponenteItems = swap.proponenteItems
  const proponenteCash = swap.proponenteMoney
  const totalProponenteCash = proponenteCash + totalItemsValue(proponenteItems)

  const destinatarioItems = swap.destinatarioItems
  const destinatarioCash = swap.destinatarioMoney
  const totalDestinatarioCash =
    destinatarioCash + totalItemsValue(destinatarioItems)

  return (
    <Row>
      <Col md={10}>
        <Card style={{ padding: 2 }}>
          <div style={styles.UserContainer}>
            <div style={{ display: 'flex' }}>
              <div style={styles.UserTitle}>
                <Link
                  style={{ color: themeColors.primary }}
                  to={`/user/${swap.proponente.username}`}>
                  {swap.proponente.username}
                </Link>
              </div>
              <div style={styles.userLabel}>Proponente</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div>
                <p style={styles.place}>
                  <FontIcon className="material-icons" style={iconStyle.place}>
                    place
                  </FontIcon>
                  <span style={{ position: 'relative', top: -7 }}>
                    {swap.proponente.district}
                  </span>
                </p>
              </div>
              <div style={styles.totalVal}>
                Valore totale{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {totalProponenteCash} €
                </span>
              </div>
            </div>
            {(swap.proponenteEsito && +swap.proponenteEsito.feedback) > 0 && (
              <div>
                <div style={{ display: 'inline-flex' }}>
                  <p style={styles.feedback}>Feedback</p>
                  <Rating
                    value={+swap.proponenteEsito.feedback}
                    onChange={noop}
                    readOnly={true}
                    itemStyle={styles.feedbackStars}
                    itemIconStyle={{ width: 17, height: 17 }}
                  />
                </div>
                {swap.proponenteEsito.motivo && (
                  <div style={styles.feedbackReason}>
                    {swap.proponenteEsito.motivo}
                  </div>
                )}
              </div>
            )}
          </div>
        </Card>

        {editable && (
          <Card style={{ padding: 3 }}>
            <RaisedButton
              label="Aggiungi Oggetto"
              labelStyle={styles.labelStyle}
              primary={true}
              icon={<AddBox style={iconStyle.btnIcon} />}
              onClick={onClickProponenteAddItems}
              className="hidden-xs"
            />
            <RaisedButton
              label="Aggiungi Denaro"
              primary={true}
              style={styles.addCashBtn}
              labelStyle={styles.labelStyle}
              icon={
                <FontIcon className="material-icons" style={iconStyle.btnIcon}>
                  {DENARO_ICON_NAME}
                </FontIcon>
              }
              onClick={onProponenteAddMoney}
              className="hidden-xs"
            />
            <RaisedButton
              label="Aggiungi Oggetto"
              labelStyle={styles.labelStyleSmall}
              primary={true}
              icon={<AddBox style={iconStyle.btnIconSmall} />}
              onClick={onClickProponenteAddItems}
              className="hidden-md hidden-lg hidden-sm"
              style={{ height: 28 }}
            />
            <RaisedButton
              label="Aggiungi Denaro"
              primary={true}
              style={styles.addCashBtnSmall}
              labelStyle={styles.labelStyleSmall}
              icon={
                <FontIcon
                  className="material-icons"
                  style={iconStyle.btnIconSmall}>
                  {DENARO_ICON_NAME}
                </FontIcon>
              }
              onClick={onProponenteAddMoney}
              className="hidden-md hidden-lg hidden-sm"
            />
          </Card>
        )}

        {proponenteCash > 0 && (
          <Card style={cashCardStyle.card}>
            <div style={{ display: 'flex' }}>
              <FontIcon className="material-icons" style={cashCardStyle.icon}>
                {DENARO_ICON_NAME}
              </FontIcon>
              <h5 style={cashCardStyle.title}>Denaro</h5>
              <div style={cashCardStyle.chip}>
                <Chip
                  style={styles.chipPositive}
                  backgroundColor={themeColors.white}
                  labelColor={themeColors.positive}>
                  € {proponenteCash}
                </Chip>
                {editable && (
                  <FlatButton
                    onClick={onProponenteClearMoney}
                    style={styles.rmBtn}
                    backgroundColor={themeColors.positive}
                    icon={<ContentRemove />}
                  />
                )}
              </div>
            </div>
          </Card>
        )}

        {proponenteItems.map(item => (
          <CardItemSwap
            showImages
            key={item.id}
            item={item}
            editable={editable}
            choosed={true}
            cardContainerStyle={styles.itemCardContainerStyle}
            cardContainerChoosedStyle={styles.itemCardContainerStyle}
            choosedColor={themeColors.primary}
            removeItem={onProponenteItemRemoved}
          />
        ))}
      </Col>

      <Col md={4} style={{ textAlign: 'center' }}>
        <div style={styles.swapBtn}>
          <img
            alt="HorizontalTrade"
            src="/img/HorizontalTrade.png"
            className="hidden-xs hidden-sm"
          />
          <img
            alt="VerticalTrade"
            src="/img/VerticalTrade.png"
            className="hidden-md hidden-lg"
          />
        </div>
      </Col>

      <Col md={10}>
        <Card style={{ padding: 2 }}>
          <div style={styles.UserContainer}>
            <div style={{ display: 'flex' }}>
              <div style={styles.UserTitle}>
                <Link
                  style={{ color: themeColors.secondary }}
                  to={`/user/${swap.destinatario.username}`}>
                  {swap.destinatario.username}
                </Link>
              </div>
              <div style={styles.userLabel}>Destinatario</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div>
                <p style={styles.place}>
                  <FontIcon className="material-icons" style={iconStyle.place}>
                    place
                  </FontIcon>
                  <span style={{ position: 'relative', top: -7 }}>
                    {swap.destinatario.district}
                  </span>
                </p>
              </div>
              <div style={styles.totalVal}>
                Valore totale{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {totalDestinatarioCash} €
                </span>
              </div>
            </div>
            {swap.destinatarioEsito &&
              +swap.destinatarioEsito.feedback > 0 && (
                <div>
                  <div style={{ display: 'inline-flex' }}>
                    <p style={styles.feedback}>Feedback</p>
                    <Rating
                      value={+swap.destinatarioEsito.feedback}
                      onChange={noop}
                      readOnly={true}
                      itemStyle={styles.feedbackStars}
                      itemIconStyle={{ width: 17, height: 17 }}
                    />
                  </div>
                  {swap.destinatarioEsito.motivo && (
                    <div style={styles.feedbackReason}>
                      {swap.destinatarioEsito.motivo}
                    </div>
                  )}
                </div>
              )}
          </div>
        </Card>
        {editable && (
          <Card style={{ padding: 3 }}>
            <RaisedButton
              label="Aggiungi Oggetto"
              labelStyle={styles.labelStyle}
              secondary={true}
              icon={<AddBox style={iconStyle.btnIcon} />}
              onClick={onClickDestinatarioAddItems}
              className="hidden-xs"
            />
            <RaisedButton
              label="Aggiungi Oggetto"
              labelStyle={styles.labelStyleSmall}
              secondary={true}
              icon={<AddBox style={iconStyle.btnIconSmall} />}
              onClick={onClickDestinatarioAddItems}
              className="hidden-md hidden-lg hidden-sm"
              style={{ height: 28 }}
            />
          </Card>
        )}

        {destinatarioCash > 0 && (
          <Card style={cashCardStyle.card}>
            <div style={{ display: 'flex' }}>
              <FontIcon className="material-icons" style={cashCardStyle.icon}>
                {DENARO_ICON_NAME}
              </FontIcon>
              <h5 style={cashCardStyle.title}>Denaro</h5>
              <div style={cashCardStyle.chip}>
                <Chip
                  style={styles.chipSecondary}
                  backgroundColor={themeColors.white}
                  labelColor={themeColors.secondary}>
                  € {destinatarioCash}
                </Chip>
                {editable && (
                  <FlatButton
                    onClick={onDestinatarioClearMoney}
                    style={styles.rmBtn}
                    backgroundColor={themeColors.secondary}
                    icon={<ContentRemove />}
                  />
                )}
              </div>
            </div>
          </Card>
        )}

        {destinatarioItems.map(item => (
          <CardItemSwap
            showImages
            key={item.id}
            item={item}
            editable={editable}
            choosed={true}
            cardContainerStyle={styles.itemCardContainerStyle}
            cardContainerChoosedStyle={styles.itemCardContainerStyle}
            choosedColor={themeColors.secondary}
            removeItem={onDestinatarioItemRemoved}
          />
        ))}
      </Col>
    </Row>
  )
}
export default pure(SwapManagement)



// WEBPACK FOOTER //
// ./src/common/Swap/SwapManagement.js